


























































import { defineComponent, toRefs } from '@vue/composition-api';
import AppButton from '@berlin-front/common/components/elements/AppButton';
import AppCard from '@berlin-front/common/components/elements/AppCard';
import AppContainer from '@berlin-front/common/components/elements/AppContainer';
import AppRow from '@berlin-front/common/components/elements/AppRow';
import AppText from '@berlin-front/common/components/elements/AppText';
import AppSupplement from '@berlin-front/common/components/elements/AppSupplement';
import ModalHeader from '@berlin-front/common/components/clusters/ModalHeader';

import { useContext } from '@berlin-front/common/composables/context';

import { ModalHeaderContext } from '@services/ModalHeaderContext';
import { HEADER_TYPE } from '@berlin-front/common/components/clusters/ModalHeader/composable';
import { TEXT_SIZE, TEXT_WEIGHT } from '@berlin-front/common/components/elements/AppText/composable';

import exclamationCircleIcon from '@berlin-front/common/assets/exclamation-circle-icon.svg';
import appleAppStoreBadge from '@berlin-front/common/assets/apple-app-store-badge.svg';
import googlePlayBadge from '@berlin-front/common/assets/google-play-badge.svg';
import { SpappLoginFailContext } from './composable';

export default defineComponent({
  name: 'SpappLoginFailView',
  components: {
    AppButton,
    AppCard,
    AppContainer,
    AppRow,
    AppSupplement,
    AppText,
    ModalHeader,
    HeaderContextConsumer: ModalHeaderContext.consumer,
  },

  setup() {
    const { useSpappLoginFailContext } = useContext(SpappLoginFailContext);
    const { cancelClick, APP_STORE_DOWNLOAD_URL, GOOGLE_PLAY_DOWNLOAD_URL } = toRefs(useSpappLoginFailContext());

    return {
      // 状態

      // 表示項目
      appleAppStoreBadgeImgSrc: appleAppStoreBadge,
      googlePlayBadgeImgSrc: googlePlayBadge,
      imgSrc: exclamationCircleIcon,
      APP_STORE_DOWNLOAD_URL,
      GOOGLE_PLAY_DOWNLOAD_URL,

      // 関数
      cancelClick,

      // 定数
      HEADER_TYPE,
      TEXT_SIZE,
      TEXT_WEIGHT,
    };
  },
});
